<template>
  <div>
    <div
      v-for="(faqItem, i) in faqData"
      :key="`faq-item-${i}`"
      class="u_margin-top-40"
    >
      <!-- eslint-disable vue/no-v-html -->
      <h2
        v-show="headerIsShowing[i]"
        class="sb_label_heading"
        v-html="faqItem.header"
      ></h2>
      <!-- eslint-enable vue/no-v-html -->

      <div
        v-for="(child, j) in faqItem.children"
        :id="`faq-item-child-${i}-${j}`"
        :ref="slugify(child.header)"
        :key="`faq-item-child-${i}-${j}`"
        :faqParent="i"
        :faqChild="j"
        class="sb_questions"
      >
        <div
          v-show="hasSearchText(child.body) || hasSearchText(child.header)"
          :ref="`faq-item-child-${i}-${j}`"

          class="sb_question_item"
        >
          <a
            class="sb_question_item_top"
            :class="{'s_is-open': (faqParent === i && faqChild === j) || search}"
            :href="`/#/faq?tab=${slugify(child.header)}`"
          >
            <div class="sb_question_item_top_left">
              <!-- eslint-disable vue/no-v-html -->
              <div
                class="sb_question_item_title"
                v-html="$options.filters.highlight(child.header, search)"
              ></div>
              <!-- eslint-enable vue/no-v-html -->
            </div>
            <div class="sb_question_item_top_right">
              <div class="sb_question_item_top_icon">
                <SvgIcon :icon-id="'icon_ui_caret-down'" />
              </div>
            </div>
          </a>

          <div class="sb_question_item_content">
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="sb_question_item_content_inner"
              v-html="$options.filters.highlight(child.body, search)"
            ></div>
            <!-- eslint-enable vue/no-v-html -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import slugify from 'slugify';

export default {
  name: 'FaqComponent',
  filters: {
    highlight(text, query) {
      if (!query) {
        return text;
      }
      const check = new RegExp(`(<)(\\/?\\b[^<>]+>)|(${query})`, 'ig');
      return text.toString().replace(check, (match, matchedOpeningTag, matchedRestHTMLTag, matchedText) => (matchedText ? `<span class="sb_highlight">${matchedText}</span>` : match));
    }
  },
  props: {
    faqData: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      faqParent: 0,
      faqChild: 0,
      headerIsShowing: []
    };
  },
  computed: {},
  watch: {
    search() {
      // sets header showing based on search items found of it's children
      this.faqData.forEach((faqItem, i) => {
        this.headerIsShowing[i] = !faqItem.children.every(faqChild => (
          !faqChild.header.includes(this.search)
          && !faqChild.body.includes(this.search)
        ));
      });
    }
  },
  mounted() {
    this.openTab(this.$route.query.tab);
    window.addEventListener('hashchange', this.hasChange);
  },
  destroyed() {
    window.removeEventListener('hashchange', this.hasChange);
  },
  created() {
    // sets all headers to show
    this.faqData.forEach((faqItem, i) => {
      this.headerIsShowing[i] = true;
    });
  },
  methods: {
    open(parent, child) {
      if (this.faqParent === parent && this.faqChild === child) {
        this.faqParent = null;
        this.faqChild = null;
        return;
      }
      this.faqParent = parent;
      this.faqChild = child;
    },
    hasSearchText(text) {
      return text.includes(this.search);
    },
    // eslint-disable-next-line no-unused-vars
    highlightedText(text) {

    },
    hasChange() {
      const tabLink = this.getParameterByName('tab', window.location.href);
      if (tabLink) {
        this.openTab(tabLink);
      }
    },
    openTab(tabLink) {
      if (this.$refs[tabLink] && this.$refs[tabLink][0]) {
        const parent = +this.$refs[tabLink][0].getAttribute('faqparent');
        const child = +this.$refs[tabLink][0].getAttribute('faqchild');
        this.open(parent, child);
        this.$nextTick(() => {
          this.$scrollTo(this.$refs[tabLink][0]);
        });
      }
    },
    getParameterByName(name, url) {
      const newName = name.replace(/[[\]]/g, '\\$&');
      const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    slugify(text) {
      const slug = slugify(text, {
        replacement: '-', // replace spaces with replacement
        remove: null, // regex to remove characters
        lower: true // result in lower case
      });
      return slug;
    }
  }
};
</script>

<style lang="scss">
.sb_question_item {
    display: block;
    margin-bottom: .3rem;


  &_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .8rem 1.2rem;
      transition: background-color .3s ease;
      user-select: none;
      background-color: #fafafa;

    @include media(">=large") {
        &:hover {
            cursor: pointer;
        }
      }

    &.s_is-open {
      background-color: #eaeaea;
        .sb_question_item_top {
        }
        + .sb_question_item_content {
            max-height: 9999px;
            overflow: inherit;
            opacity: 1;
            padding: .8rem 1.2rem;
        }
        .sb_question_item_top_icon {
            transform: rotate(180deg);
        }
    }
  }
  &_top_left {
  }
  &_top_right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      overflow: hidden;
      position: relative;
      flex: 0 0 50px;
      min-width: 50px;
      @include media(">=medium") {
          width: 60%;
          min-width: inherit;
      }
  }
  &_top_icon {
      margin: 0 0 0 1rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: transform .3s ease;
      svg {
          transform: scale(1.1) translateY(1px);
      }
  }
  &_title {
      transition: color .3s ease;
  }
  &_content {
      overflow: hidden;
      max-height: 0px;
      opacity: 0;
      padding: 0;
  }
  &_content_inner {
      padding: $default-padding / 2 0;
  }
}
.sb_highlight {
    background: yellow;
    border-radius: 3px;
}

//
// BRAND STYLING
//
@include sb_questions;

</style>
